/**
 * Represents the zeus.apollon_fk_conf.conf.kontakte value object - the Foerderkategorie config
 * json structure
 *
 * This file is part of Zeus Apollon
 *
 * (c) Kaden und Partner AG
 */
import { createModel, Model, type MutationsObject } from '@kp/js-model';
import { DokumenteConfig } from '@/models/apollon_conf_fk/DokumenteConfig';

export class Dokumente extends Model {
    beilagen: DokumenteConfig | null = null;
    div_dokumente: DokumenteConfig | null = null;
    formulare: DokumenteConfig | null = null;

    public mutations(): MutationsObject {
        return {
            beilagen: (val: DokumenteConfig) => createModel(DokumenteConfig, val),
            div_dokumente: (val: DokumenteConfig) => createModel(DokumenteConfig, val),
            formulare: (val: DokumenteConfig) => createModel(DokumenteConfig, val),
        };
    }
}
